import cloneDeep from "lodash.clonedeep"

export const cloneDeepObject = (...parameters) => cloneDeep(...parameters)

export default cloneDeepObject
